const CirclePlus = ({ ...props }) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
      <circle cx="12.6562" cy="12.7363" r="12.5" fill={props.fillColor} />
      <line
        x1="12.6611"
        y1="6.73633"
        x2="12.6611"
        y2="18.7363"
        stroke="white"
      />
      <line
        x1="18.6562"
        y1="12.7422"
        x2="6.65625"
        y2="12.7422"
        stroke="white"
      />
    </svg>
  )
}

export default CirclePlus
